import type { ActionDefinitions, ActionResult } from 'actions/Action';
import type { ActionEntity } from 'actions/ActionEntity';
import { showEditReportDefinition } from './edit/showEditReportDefinition';

type ReportDefinitionEntity = Extract<ActionEntity, { type: 'report_definition' }>;

const isAllReportDefinition = (entities: readonly ActionEntity[]): entities is readonly ReportDefinitionEntity[] =>
  entities.every((entity) => entity.type === 'report_definition');

/**
 * Action definitions for report definitions — only `edit` (single). The page
 * has no create / delete / transport, and the old "Run" menu item was a no-op
 * (its handler was commented out), so it is dropped.
 */
export const reportDefinitionActionDefinitions: ActionDefinitions = [
  {
    id: 'edit',
    label: 'Edit',
    resolve: (ctx): ActionResult => {
      const { entities, refresh } = ctx;
      if (!isAllReportDefinition(entities)) return 'hidden';
      if (entities.length !== 1) return 'disabled';
      const [only] = entities;
      return () => showEditReportDefinition(only.id, refresh);
    },
  },
];
